import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
import { menuAside, menuHeader } from '@/menu';
export default {
  name: 'feature',
  data: function data() {
    return {
      featureList: [],
      checkAll: false,
      isIndeterminate: false,
      checkedCities: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var list;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.featureList = window.localStorage.getItem('Menu') ? JSON.parse(window.localStorage.getItem('Menu')) : [];
              _context.next = 3;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'menu.accessMenus',
                defaultValue: [],
                user: true
              }, {
                root: true
              });

            case 3:
              list = _context.sent;
              _this.checkedCities = list.map(function (item) {
                return _this.featureList.filter(function (i) {
                  return (i === null || i === void 0 ? void 0 : i.title) == item.title;
                })[0];
              });
              _this.checkedCities = _this.checkedCities.map(function (item) {
                return item.id;
              });
              _this.isIndeterminate = _this.checkedCities.length && _this.checkedCities.length != _this.featureList.length ? true : false;
              _this.checkAll = _this.checkedCities.length == _this.featureList.length ? true : false;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {},
  methods: {
    confimFeature: function confimFeature() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list, accessMenus;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = _this2.checkedCities.map(function (item) {
                  return _this2.featureList.filter(function (i) {
                    return (i === null || i === void 0 ? void 0 : i.id) == item;
                  })[0];
                });
                _context2.next = 3;
                return _this2.$store.dispatch('d2admin/permission/generateAccessMenus', list);

              case 3:
                accessMenus = _context2.sent;

                // 设置顶栏菜单
                _this2.$store.commit('d2admin/menu/headerSet', [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus))); // 设置侧边栏菜单


                _this2.$store.commit('d2admin/menu/asideSet', [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus))); // 初始化菜单搜索功能


                _this2.$store.commit('d2admin/search/init', [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus)));

                _context2.next = 9;
                return _this2.$store.dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'menu.accessMenus',
                  value: accessMenus,
                  user: true
                }, {
                  root: true
                });

              case 9:
                _context2.next = 11;
                return _this2.$store.dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'menu.Settings',
                  value: true,
                  user: true
                }, {
                  root: true
                });

              case 11:
                _context2.next = 13;
                return _this2.$store.dispatch('d2admin/page/closeAll', {}, {
                  root: true
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.featureList.map(function (item) {
        return item.id;
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.featureList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.featureList.length;
    }
  }
};